import { Box } from "@material-ui/core";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import AppButton from "components/CustomButtons/AppButton";
import { ACCOUNTING_TYPE } from "config/AppConfig";
import { useDispatch, useSelector } from "react-redux";
import {
  reduceConnectToXero,
  reduceConnectToQuickBook,
  reduceDisconnectToAccounting,
} from "store/slices/company";
import { getAuthInfo } from "store/slices/auth";
import { useEffect } from "react";
import XeroAccounting from "assets/icons/xero.svg";
import QuickBookAccounting from "assets/icons/quickbooks.svg";
import { useLocation, useHistory } from "react-router-dom";

const AccountingAccountForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { search, state } = useLocation();
  const queryURL = new URLSearchParams(search);
  const redirectUri = `${window.location.origin}/admin/setting-accounting`;

  const [loading, setLoading] = useState(false);

  const authInfo = useSelector(getAuthInfo);

  const { accountingType } = authInfo;

  const accountingAccountList = [
    {
      id: ACCOUNTING_TYPE.XERO,
      connectLabel: t("label.connectXeroAccounting"),
      disConnectLabel: t("label.disconnectXeroAccounting"),
      connectedLabel: t("label.connectedXeroAccounting"),
      src: XeroAccounting,
    },
    {
      id: ACCOUNTING_TYPE.QUICKBOOKS,
      connectLabel: t("label.connectQuickBookAccounting"),
      disConnectLabel: t("label.disconnectQuickBookAccounting"),
      connectedLabel: t("label.connectedQuickBookAccounting"),

      src: QuickBookAccounting,
    },
  ];

  useEffect(() => {
    const code = queryURL.get("code");
    const realmId = queryURL.get("realmId");
    const state = queryURL.get("state");
    if (code && realmId && state === "quickbook_token") {
      history.push("/admin/setting-accounting", {
        search: "",
        isCallback: true,
      });
      handleCallBackConnectQuickbook(code, realmId);
    }
    if (code && state === "xero_token") {
      history.push("/admin/setting-accounting", {
        search: "",
        isCallback: true,
      });
      handleCallBackConnectXero(code);
    }
  }, []);

  useEffect(() => {
    if (state && state.isCallback) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, []);

  const handleConnectAccounting = (id) => {
    switch (id) {
      case ACCOUNTING_TYPE.XERO:
        handleConnectToXero();
        break;
      case ACCOUNTING_TYPE.QUICKBOOKS:
        handleConnectToQuickbook();
        break;
    }
  };

  const handleDisConnect = async (accountingType) => {
    setLoading(true);
    await dispatch(
      reduceDisconnectToAccounting({ accountingType: accountingType })
    );
    setLoading(false);
  };
  console.log('node ,', process.env.REACT_APP_ENV);

  const handleConnectToXero = () => {
    setLoading(true);
    // for production
    // window.open(`https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${process.env.REACT_APP_XERO_CLIENT_ID}&redirect_uri=${redirectUri}&scope=offline_access accounting.transactions accounting.transactions.read accounting.reports.tenninetynine.read accounting.journals.read accounting.settings accounting.contacts accounting.attachments payroll.employees payroll.payruns payroll.payslip payroll.timesheets payroll.settings&state=xero_token`, '_self')
    // for dev
    if (process.env.REACT_APP_ENV !== "production") {
      window.open(
        `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${process.env.REACT_APP_XERO_CLIENT_ID}&redirect_uri=${redirectUri}&scope=offline_access 
        accounting.invoices accounting.payments accounting.banktransactions accounting.manualjournals accounting.reports.aged.read accounting.reports.balancesheet.read accounting.reports.banksummary.read accounting.reports.budgetsummary.read accounting.reports.executivesummary.read accounting.reports.profitandloss.read accounting.reports.trialbalance.read 
        accounting.reports.taxreports.read accounting.reports.tenninetynine.read accounting.settings accounting.contacts accounting.attachments 
        payroll.employees payroll.payruns payroll.payslip payroll.timesheets payroll.settings &state=xero_token`,
        "_self"
      );
    } else {
      window.open(
        `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${process.env.REACT_APP_XERO_CLIENT_ID}&redirect_uri=${redirectUri}&scope=offline_access 
        accounting.invoices accounting.payments accounting.banktransactions accounting.manualjournals accounting.reports.aged.read accounting.reports.balancesheet.read accounting.reports.banksummary.read accounting.reports.budgetsummary.read accounting.reports.executivesummary.read accounting.reports.profitandloss.read accounting.reports.trialbalance.read 
        accounting.reports.taxreports.read accounting.reports.tenninetynine.read accounting.settings accounting.contacts accounting.attachments 
        payroll.employees payroll.payruns payroll.payslip payroll.timesheets payroll.settings &state=xero_token`,
        "_self"
      );
    }
  };

  const handleConnectToQuickbook = () => {
    setLoading(true);
    window.open(
      `https://appcenter.intuit.com/connect/oauth2?client_id=${process.env.REACT_APP_QUICKBOOK_CLIENT_ID}&response_type=code&scope=com.intuit.quickbooks.accounting&redirect_uri=${redirectUri}&state=quickbook_token`,
      "_self"
    );
  };

  const handleCallBackConnectXero = async (code) => {
    const request = {
      code: code,
      redirect_uri: redirectUri,
    };
    await dispatch(reduceConnectToXero(request));
    history.push("/admin/setting-accounting", {
      search: "",
      isCallback: false,
    });
  };

  const handleCallBackConnectQuickbook = async (code, realmId) => {
    setLoading(true);
    const request = {
      code: code,
      realmId: realmId,
      redirect_uri: redirectUri,
    };
    await dispatch(reduceConnectToQuickBook(request));
    history.push("/admin/setting-accounting", {
      search: "",
      isCallback: false,
    });
  };

  return (
    <Box style={{ height: "75vh" }}>
      {!accountingType &&
        accountingAccountList.map((item) => {
          return (
            <AppButton
              key={item.id}
              label={item.connectLabel}
              onClick={() => handleConnectAccounting(item.id)}
              buttonColor={"#FFFFFF"}
              style={{
                border: "1px solid #dee2e6",
                marginLeft: item.id !== "xero" ? "20px" : "",
                color: "#000000",
              }}
              startIcon={
                <img src={item.src} style={{ width: "35px", height: "35px" }} />
              }
              disabled={loading}
              isLoading={loading}
            />
          );
        })}
      {accountingType &&
        accountingAccountList.map((item) => {
          if (item.id === accountingType) {
            return (
              <AppButton
                key={item.id}
                label={item.connectedLabel}
                // onClick={() => handleDisConnect(accountingType || item.id)}
                buttonColor={"#FFFFFF"}
                style={{
                  border: "1px solid #dee2e6",
                  marginLeft: item.id !== "xero" ? "20px" : "",
                  color: "#000000",
                }}
                startIcon={
                  <img
                    src={item.src}
                    style={{ width: "35px", height: "35px" }}
                  />
                }
                disabled={loading}
                isLoading={loading}
              />
            );
          }
        })}
    </Box>
  );
};

export default AccountingAccountForm;
